import React, { forwardRef, useEffect } from 'react';
import ReactPatternLock from 'react-pattern-lock';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link, useParams } from 'react-router-dom';
import { useExpiredlink, useResetPattern } from './api/apiAuthentication';
import { RotateCcw } from 'lucide-react';
import { CircularProgress } from '@mui/material';
import logocolor from '../assets/images/logocolor.png';

const schema = yup.object().shape({
    newPattern: yup
        .array()
        .min(1, 'Draw a pattern')
        .required()
        .min(4, 'Connect atleast 4 dots'),
    confirmNewPattern: yup
        .array()
        .min(1, 'Draw a pattern')
        .required()
        .min(4, 'Connect atleast 4 dots')
})

const defaultValues = {
    newPattern: [],
    confirmNewPattern: []
}

// eslint-disable-next-line react/display-name
const PatternLock = forwardRef((props, ref) => (
    <ReactPatternLock {...props} ref={ref} />
))

const ResetPattern = () => {

    const resetPatternmutation = useResetPattern()
    const params = useParams()
    const link = params?.id || ''

    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, getValues, clearErrors } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    })

    const clearPattern = (pattern) => {
        if (getValues(pattern).length === 0) return
        setValue(pattern, [])
    }

    const { mutate: checkUrl } = useExpiredlink()
    useEffect(() => {
        checkUrl({ "token": link, url: 'reset-pattern' });
    }, [checkUrl, link]);

    const validatePatterns = () => {
        const pattern = getValues('newPattern')
        const confirmNewPattern = getValues('confirmNewPattern')

        if (pattern.length > 0 && confirmNewPattern.length > 0) {
            if (JSON.stringify(pattern) !== JSON.stringify(confirmNewPattern)) {
                setError('confirmNewPattern', { type: 'required', message: "Patterns didn't match" })
                setTimeout(() => {
                    setValue('newPattern', [])
                    setValue('confirmNewPattern', [])
                    clearErrors('confirmNewPattern')
                }, 1000)
            }
        }
    }

    const onSubmit = async (data) => {
        const obj = {
            token: link,
            pattern: data.newPattern.map((e) => e + 1).join(''),
            confirmPattern: data.confirmNewPattern.map((e) => e + 1).join(''),
        }

        const res = await resetPatternmutation.mutateAsync(obj)
        if (res.status) reset()
    }


    return (

        <div className='LoginRegBg'>
            <div className='crPg-bg-color crPg-bg-image'>
                <section>
                    <div className="container">
                        <div className="row align-items-center justify-content-center min-vh-100 py-4">
                            <div className="col">

                                <div className="crPgBr mx650">
                                    <div className="crPg">

                                        <div className="crPgFrm crPgFrmIps">
                                            <div className="crPgLogo text-center mx-438">
                                                <img src={logocolor} className='img-fluid' alt="Logo" />

                                            </div>
                                            <div className="crPgWclTx crPgWcl-tx-color pb-4 mb-2">
                                                <h1>Reset Pattern</h1>
                                                <p>Enter your pattern to access the admin.</p>
                                            </div>


                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="row justify-content-center">
                                                    <div className="col-md-6">
                                                        <div className="form-group text-center text-md-start">
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <label className="pb-2 mb-1" htmlFor="newPattern">New Pattern</label>                                                                <button type="button" className="btn btn-outline-link p-0" onClick={() => clearPattern("newPattern")}>
                                                                    <RotateCcw size={20} />
                                                                </button>
                                                            </div>
                                                            <div className="pdLock text-center">
                                                                <Controller
                                                                    name='newPattern'
                                                                    control={control}
                                                                    render={({ ref, field }) => (
                                                                        <PatternLock
                                                                            {...field}
                                                                            ref={ref}
                                                                            width={300}
                                                                            size={3}
                                                                            disabled={resetPatternmutation.isLoading}
                                                                            path={field.value}
                                                                            style={{
                                                                                margin: "0 auto"
                                                                            }}
                                                                            onFinish={() => { }}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            {errors.newPattern && <p className="errMsg">* {errors.newPattern.message}</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-4 mt-md-0">
                                                        <div className="form-group text-center text-md-start">
                                                            <div className='d-flex justify-content-between align-items-center'>
                                                                <label className="pb-2 mb-1" htmlFor="confirmPattern">Confirm Pattern</label>
                                                                <button type="button" className="btn btn-outline-link p-0" onClick={() => clearPattern("confirmNewPattern")}>
                                                                    <RotateCcw size={20} />
                                                                </button>
                                                            </div>
                                                            <div className="pdLock text-center">
                                                                <Controller
                                                                    name='confirmNewPattern'
                                                                    control={control}
                                                                    render={({ ref, field }) => (
                                                                        <PatternLock
                                                                            {...field}
                                                                            ref={ref}
                                                                            width={300}
                                                                            size={3}
                                                                            disabled={resetPatternmutation.isLoading}
                                                                            path={field.value}
                                                                            style={{
                                                                                margin: "0 auto"
                                                                            }}
                                                                            onFinish={validatePatterns}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                            {errors.confirmNewPattern && <p className="errMsg">* {errors.confirmNewPattern.message}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-grid crPgbtn pt-4 mt-2">
                                                    <button type="submit" className="btn btn-primary btn350" disabled={resetPatternmutation.isLoading}>
                                                        {resetPatternmutation.isLoading ? <CircularProgress size={30} style={{ color: "#fff" }} /> : "Reset Pattern"}
                                                    </button>
                                                </div>
                                                <div className='fgtLks text-center mt-2 BacktoLogin'>
                                                    <p>Back to <Link to="/">Login</Link></p>
                                                </div>
                                            </form>


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    )
}
export default ResetPattern;